<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-25 17:37:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.nameOrCode" placeholder="品牌合同名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.brandName" placeholder="合作品牌"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.businessPrincipalId" placeholder="合同负责人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="formInline.projectType" placeholder="未选择项目类型">
          <el-option label="代运营" :value="1"></el-option>
          <el-option label="媒介" :value="2"></el-option>
          <el-option label="Campaign" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="formInline.status" placeholder="未选择合同状态">
          <div v-for="(item,index) in contractStatus" :key="index">
            <el-option v-if="item" :label="item" :value="index"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="formInline.sealStatus" placeholder="未选择盖章状态">
          <div v-for="(item,index) in sealStatusList" :key="index">
            <el-option v-if="item" :label="item" :value="index"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="timeAll"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd" 
          format="yyyy-MM-dd"
          start-placeholder="最早创建时间"
          @change="datePickerChange"
          end-placeholder="最晚创建时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
        <el-button type="primary" size="small" @click="onExport">导出</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">商务合同总数：{{total}}条</div>
    <el-table v-loading="loading" size="small" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="name" label="品牌合同名称">
        <template slot-scope="scope">
          <div>{{scope.row.name}}</div>
          <div>{{scope.row.ourCode}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="money" label="合同金额"></el-table-column>
      <el-table-column align="center" prop="projectType" label="项目类型">
        <template slot-scope="scope">
          <div>
            {{projectTypeList[scope.row.projectType]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="brandName" label="合作品牌"></el-table-column>
      <el-table-column align="center" prop="signSubject" label="签约主体"></el-table-column>
      <el-table-column align="center" prop="businessPrincipalName" label="合同负责人"></el-table-column>
      <el-table-column align="center" prop="fileList" label="品牌合同文件">
         <template slot-scope="scope">
           <filePreview :fileList="scope.row.fileList"></filePreview>
          <!-- <div v-for="(item,index) in scope.row.fileList" :key="index">
            <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.name">{{ item.name }}</a>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="合同状态">
        <template slot-scope="scope">
          <div>
            {{contractStatus[scope.row.status]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sealStatus" label="盖章状态">
        <template slot-scope="scope">
          <div>
            {{sealStatusList[scope.row.sealStatus]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="date" label="操作" width="200">
        <template slot-scope="scope">
          <!-- 合同状态 1-启动审批中; 2-启动审批不通过; 3-进行中; 4-结案审核中; 5-结案审核不通过; 6-已结案; -->
          <!-- 盖章状态 1-待申请盖章；2-盖章审核中；3-盖章审核不通过；4-待盖章；5-已盖章； -->
          <!-- 启动审核中,待申请盖章  -->
          <div v-if="scope.row.status == 1 && scope.row.sealStatus == 1">
            <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
            <el-button size="small" type="text" @click="approvalDeatilClick(scope.row.id)">启动审批详情</el-button>
            <el-button size="small" type="text" @click="deleteClick(scope.row.id)">删除</el-button>
          </div>
          <!-- 启动审核不通过,待申请盖章 -->
          <div v-if="scope.row.status == 2 && scope.row.sealStatus == 1">
            <el-button size="small" type="text" @click="addClick(scope.row.id)">重新申请</el-button>
            <el-button size="small" type="text" @click="approvalDeatilClick(scope.row.id)">启动审批详情</el-button>
            <el-button size="small" type="text" @click="deleteClick(scope.row.id)">删除</el-button>
          </div>
          <!-- 进行中 -->
          <div v-if="scope.row.status==3">
            <!-- 待申请盖章 -->
            <div v-if="scope.row.sealStatus == 1">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="sealClick(scope.row.id,'申请盖章')">申请盖章</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClickSP(scope.row.id)">申请结案</el-button>
            </div>
            <!-- 盖章审核中 -->
            <div v-if="scope.row.sealStatus == 2">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="sealDetailClick(scope.row.id)">盖章审批详情</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClickSP(scope.row.id)">申请结案</el-button>
            </div>
            <!-- 盖章审核不通过 -->
            <div v-if="scope.row.sealStatus == 3">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="sealClick(scope.row.id,'重新申请盖章')">重新申请盖章</el-button>
              <el-button size="small" type="text" @click="sealDetailClick(scope.row.id)">盖章审批详情</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClickSP(scope.row.id)">申请结案</el-button>
            </div>
            <!-- 待盖章,已盖章 -->
            <div v-if="scope.row.sealStatus == 4 || scope.row.sealStatus == 5">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClickSP(scope.row.id)">申请结案</el-button>
            </div>
          </div>
          <!-- 已盖章 -->
          <div v-if="scope.row.sealStatus==5">
            <!-- 结案审核中 -->
            <div v-if="scope.row.status==4">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClick(scope.row.id)">结案审批详情</el-button>
            </div>
            <!-- 结案审核不通过 -->
            <div v-if="scope.row.status==5">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="invoiceDetailClick(scope.row)">申请开票</el-button>
              <el-button size="small" type="text" @click="caseDetailClickSP(scope.row.id)">重新申请结案</el-button>
              <el-button size="small" type="text" @click="caseDetailClick(scope.row.id)">结案审批详情</el-button>
            </div>
            <!-- 已结案 -->
            <div v-if="scope.row.status==6">
              <el-button size="small" type="text" @click="editClick(scope.row.id,scope.row.status,scope.row.sealStatus)">编辑</el-button>
              <el-button size="small" type="text" @click="caseDetailClick(scope.row.id)">结案审批详情</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 启动审批详情 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="approvalDialog"
      width="30%">
      <!-- 启动审批详情,盖章审批详情-->
      <div v-if="neiShow">
        <div>直属上级审批：{{finalApproval.directLeaderName}}</div>
        <div v-if="finalApproval.directLeaderNameList" style="padding-top:10px;">
          (直属上级可审批人
          <span v-for="(item,index) in finalApproval.directLeaderNameList" :key="index">
            {{item}},
          </span>)
        </div>
        <div v-if="dialogTitle == '盖章审批详情'" style="padding:10px 0;">审批状态：{{sealApprovalStatusList[finalApproval.auditStatus]}}</div>
        <div v-else style="padding:10px 0;">
          审批状态：{{StartApprovalStatusList[finalApproval.auditStatus]}}
        </div>
        <div>审批备注：{{finalApproval.auditRemark}}</div>
      </div>
      <!-- 结案审批详情 finalApproval-->
      <div v-else>
        <div class="details-top">
          <div>直属上级审批：{{finalApproval.directLeaderName}}</div>
          <div>财务审批人：{{finalApproval.treasurerName}}</div>
          <div>出纳审批人：{{finalApproval.cashierName}}</div>
        </div>
        <div style="padding-top:10px;">
          <div v-if="finalApproval.directLeaderNameList">
            (直属上级可审批人
            <span v-for="(item,index) in finalApproval.directLeaderNameList" :key="index">
              {{item}},
            </span>)
          </div>
          <div v-if="finalApproval.treasurerNameList">
            (财务可审批人
            <span v-for="(item,index) in finalApproval.treasurerNameList" :key="index">
              {{item}},
            </span>)
          </div>
          <div v-if="finalApproval.cashierNameList">
            (出纳可审批人
            <span v-for="(item,index) in finalApproval.cashierNameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div style="padding:10px 0;">审批状态：{{auditStatusList[finalApproval.auditStatus]}}</div>
        <div>审批备注：{{finalApproval.auditRemark}}</div>
      </div>
    </el-dialog>
    <!-- 申请开票提醒,申请结案提醒 -->
    <el-dialog
      :title="InvoiceCaseTitle"
      :visible.sync="dialogInvoiceCase"
      width="30%">
      <!-- 申请开票提醒-->
      <div v-if="InvoiceCaseShow">
        <div style="margin-bottom: 10px">申请开票条件：</div>
        <div class="invoiceList">
          <span>1，盖章状态为已盖章</span>
          <i v-if="invoiceDetailData.isSealed" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>2，剩余可申请开票金额大于0</span>
          <i v-if="invoiceDetailData.hasRemainingMoney" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
      <div v-else>
        <div style="margin-bottom: 10px">申请结案条件：</div>
        <div class="invoiceList">
          <span>1，盖章状态为已盖章</span>
          <i v-if="brandContractFinish.isSealed" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>2，剩余可申请开票金额为0</span>
          <i v-if="brandContractFinish.remainingMoneyZero" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>3，合同的全部信息必须填写完整（合同备注除外）</span>
          <i v-if="brandContractFinish.isContractCompleted" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
    </el-dialog>
    <!-- 申请开票 -->
    <InvoiceDialog ref="invoiceDialog" @invoiceSubmit="invoiceSubmit"></InvoiceDialog>
    <!-- 申请盖章,重新申请盖章 -->
    <dialogAttach ref="dialogAttachBom" @saveCommonClick="saveCommonClick"></dialogAttach>
  </div>
</template>

<script>
import { 
  brandContractPage,      //品牌合同列表
  brandContractSealInfo,  //获取品牌合同的盖章信息
  brandContractApplySeal, //申请盖章/重新申请盖章
  brandContractApplyFinish,//申请结案/重新申请结案
  brandContractFinishCondition,//查看结案条件
  brandContractInvoiceCondition,//查看品牌合同开票条件
  brandContractInvoiceBrandInfo,//获取品牌信息
  brandContractInvoiceApply,    //开票申请/作废后重新申请开票
  brandContractAuditDetail,     //查询审批详情
  brandContractDelete,//删除品牌合同
  brandContractExport,//导出
  } from '@/api/brandContract'
import InvoiceDialog from './Invoicedialog'
import dialogAttach from "@/components/common/dialogAttach"
import validate from "@/util/validate";
export default {
  components: {
    InvoiceDialog,
    dialogAttach,
  },
  data() {
    return {
      loading:false,
      projectTypeList:['','代运营','媒介','Campaign'],
      contractStatus:['','启动审批中', '启动审批不通过', '进行中', '结案审核中', '结案审核不通过', '已结案',],
      sealStatusList:['','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章',],
      auditStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过/待财务审批','财务审批不通过','财务审批通过/待出纳审批','出纳审批不通过','出纳审批通过'],//结案审批状态
      sealApprovalStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过',],//盖章审批状态
      StartApprovalStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过'],//启动审批状态
      formInline: {
        brandName:"",//合作品牌
        businessPrincipalId:"",//合同负责人
        nameOrCode:"",//品牌合同名称/编号
        projectType:"",//项目类型
        sealStatus:"",//盖章状态
        status:"",//合同状态
        startTime:"",//最早创建时间
        endTime:"",//最晚创建时间
        pageNum: 1,
        pageSize: 10,
      },
      timeAll:"",
      tableData:[],
      total:0,
      // 启动审批详情,盖章审批详情,结案审批详情
      approvalDialog:false,
      dialogTitle:"",
      neiShow:true,
      //申请开票提醒,申请结案提醒
      dialogInvoiceCase:false,
      InvoiceCaseTitle:"",
      InvoiceCaseShow:true,
      brandContractFinish:"",//查看结案条件
      invoiceDetailData:"",//查看开票条件
      finalApproval:"",//结案审批详情
    };
  },
  mounted() {
    this.getDataInit()
  },
  methods: {
    /**
	   * 导出
	   */
	  onExport() {
	    let queryObj = validate.removeFilterNull(this.formInline);
	    console.log(queryObj);
	    brandContractExport(queryObj).then((res) => {
	      const blob = new Blob([res.data]);
	      let fileName = res.headers["content-disposition"].split("filename=")[1];
	      fileName = decodeURI(fileName);
	      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	        window.navigator.msSaveOrOpenBlob(blob, fileName);
	      } else {
	        const linkNode = document.createElement("a");
	        linkNode.download = fileName; //a标签的download属性规定下载文件的名称
	        linkNode.style.display = "none";
	        linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
	        document.body.appendChild(linkNode);
	        linkNode.click(); //模拟在按钮上的一次鼠标单击
	        URL.revokeObjectURL(linkNode.href); // 释放URL 对象
	        document.body.removeChild(linkNode);
	      }
	      setTimeout(() => {
	        this.$message.success("导出成功，等待文件下载完毕");
	      }, 500);
	    });
	  },
    datePickerChange(vlaue){
      if(vlaue){
        this.formInline.startTime = vlaue[0] + " 00:00:00"
        this.formInline.endTime = vlaue[1] + " 23:59:59"
      }else{
        this.formInline.startTime = ""
        this.formInline.endTime = ""
      }
      console.log('========',vlaue)
    },
    getDataInit(){
      this.loading = true;
      brandContractPage(this.formInline).then(res=>{
        this.tableData = res.data;
        this.total = res.total
        this.loading = false;
      })
    },
    //查询
    onSearch(){
      this.formInline.pageNum = 1;
      this.getDataInit()
    },
    //重新申请-跳转新增页面
    addClick(id){
      let router = this.$router.resolve({
        path: `/brandContract/add`,
        query: {id,type:'add'},
      });
      window.open(router.href);
    },
    //跳转编辑页面
    editClick(id,status,sealStatus){
      let router = this.$router.push({
        path: `/brandContract/edit`,
        query: {id,status,sealStatus},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    //申请盖章、重新申请盖章
    saveCommonClick(item){
      brandContractApplySeal(item).then(res=>{
        if(res.code === 1){
          this.$message.success('申请成功!')
          this.$refs.dialogAttachBom.dialogTableVisible = false;
          this.getDataInit()
        }
        console.log('====申请盖章、重新申请盖章====',res)
      })
    },
    //申请盖章、重新申请盖章按钮
    sealClick(id,name){
      console.log('=====申请盖章=====',id);
      brandContractSealInfo({id:id}).then(res=>{
        console.log('=======aaaaa=====',res)
        if(res.code === 1){
          this.$refs.dialogAttachBom.dialogTableVisible = true;
          this.$refs.dialogAttachBom.variableNameA = "品牌合同文件";
          this.$refs.dialogAttachBom.variableNameB = "上传品牌合同文件";
          this.$refs.dialogAttachBom.dialogTitle = name;
          this.$refs.dialogAttachBom.ruleForm = {
            id:id,
            isSave:"",
            sealOperatorId:res.data.data.sealOperatorId,
            sealOperatorName:res.data.data.sealOperatorName,
            sealType:res.data.data.sealType,
            fileList:res.data.data.fileList,
          }
        }
      })
      
    },
    //申请开票提交按钮
    invoiceSubmit(item){
      brandContractInvoiceApply(item).then(res=>{
        if(res.code === 1){
          this.$message.success('申请成功!')
          this.getDataInit()
          this.$refs.invoiceDialog.dialogShow = false;
        }
        console.log('====申请开票提交====',res)
      })
    },
    //申请开票
    invoiceDetailClick(data){
      brandContractInvoiceCondition({brandContractId:data.id}).then(res=>{
        if(!res.data.isSealed || !res.data.hasRemainingMoney){
          this.dialogInvoiceCase = true
          this.InvoiceCaseShow = true
          this.InvoiceCaseTitle = "申请开票提醒"
          this.invoiceDetailData = res.data
        }else{
          this.$refs.invoiceDialog.dialogShow = true;
          this.$refs.invoiceDialog.remainingMoney = res.data.remainingMoney // 开票金额
          brandContractInvoiceBrandInfo({brandId:data.brandId}).then(item=>{
            this.$refs.invoiceDialog.InvoiceForm={
              brandContractId: data.id, //合同ID
              signSubject: item.data.signSubject, //名称
              companyPhone: item.data.companyPhone, //电话
              companyAddress: item.data.companyAddress, //公司地址
              taxpayerId: item.data.taxpayerId, //纳税人识别号
              depositBank: item.data.depositBank, //客户开户行
              bankAccount: item.data.bankAccount, //客户银行账户
              invoiceMoney: "", //开票金额
              invoiceType: "", //发票类型
              invoiceDetail: "", //开票明细
              remark: "", //合同备注
              finAccountId:"",
            }
          })
        }
      })
    },
    //申请结案
    caseDetailClickSP(id){
      brandContractFinishCondition({id:id}).then(res=>{
        if(!res.data.isSealed || !res.data.remainingMoneyZero || !res.data.isContractCompleted){
          this.dialogInvoiceCase = true;
          this.InvoiceCaseShow = false
          this.InvoiceCaseTitle = "申请结案提醒"
          this.brandContractFinish = res.data
        }else{
          this.$confirm('确定申请结案吗？申请结案后，品牌合同的全部信息（合同备注除外）将不再支持修改！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //申请结案
            brandContractApplyFinish(id).then(res=>{
              if(res.code === 1){
                this.$message.success('申请成功!')
                this.getDataInit()
              }
            })
          }).catch(() => {});
        }
      })
    },
    //审批详情接口 type 10-品牌合同启动审批, 11-品牌合同结案审批, 12-品牌合同盖章审批
    async getBrandContractAuditDetail(id,type){
      let res = await brandContractAuditDetail({auditType:type,id});
      return res.data
    },
    //启动审批详情
    async approvalDeatilClick(id){
      this.finalApproval = await this.getBrandContractAuditDetail(id,10);
      this.dialogTitle = '启动审批详情'
      this.neiShow = true
      this.approvalDialog = true

    },
    //盖章审批详情
    async sealDetailClick(id){
      this.finalApproval = await this.getBrandContractAuditDetail(id,12);
      this.dialogTitle = '盖章审批详情'
      this.neiShow = true
      this.approvalDialog = true
    },
    //结案审批详情
    async caseDetailClick(id){
      this.finalApproval = await this.getBrandContractAuditDetail(id,11);
      this.dialogTitle = '结案审批详情'
      this.neiShow = false
      this.approvalDialog = true
    },
    //删除
    deleteClick(id){
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        brandContractDelete({id}).then(res=>{
          if(res.code === 1){
            this.$message.success('删除成功!')
            this.getDataInit()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getDataInit()
    }
  },
};
</script>
<style lang="scss" scoped>
.details-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}

/deep/.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 35px;
    height: 35px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      font-size: 36px !important;
    }
    cursor: pointer;
  }
}
/deep/.select-tag {
  .el-tag__close{
    top: -8px;
  }
}
</style>